export default "__VITE_ASSET__DrBA4PIN__"